import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/roles";

const STATUSES = [["", "Tutti"], ["disponibile", "Disponibili"], ["venduto", "Venduti"], ["rimosso", "Rimossi"]];
const sel = "h-10 rounded-md border border-[var(--border)] px-3 text-sm bg-white";

export function ItemFilters({ f, setF, categories, lots }) {
  const { user } = useAuth();
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="space-y-3" data-testid="wh-filters">
      <div className="flex flex-wrap gap-2">
        {STATUSES.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setF({ ...f, status: k })} data-testid={`wh-filter-status-${k || "all"}`}
            className={`h-9 px-4 rounded-full text-sm font-semibold border transition-colors ${f.status === k ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "bg-white border-[var(--border)]"}`}>{l}</button>
        ))}
      </div>
      <details className="rounded-xl border border-[var(--border)] bg-white p-3">
        <summary className="text-sm font-semibold cursor-pointer" data-testid="wh-more-filters">Altri filtri</summary>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3">
          <select value={f.category} onChange={set("category")} className={sel} data-testid="wh-filter-category">
            <option value="">Tutte le categorie</option>{categories.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          {lots && <select value={f.lot_id} onChange={set("lot_id")} className={sel} data-testid="wh-filter-lot">
            <option value="">Tutti i lotti</option><option value="none">Senza lotto</option>{lots.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
          </select>}
          <Input type="number" min="0" placeholder="Vendita da €" value={f.smin} onChange={set("smin")} data-testid="wh-filter-smin" />
          <Input type="number" min="0" placeholder="Vendita fino a €" value={f.smax} onChange={set("smax")} data-testid="wh-filter-smax" />
          {can(user, "wh_cost") && <Input type="number" min="0" placeholder="Acquisto da €" value={f.cmin} onChange={set("cmin")} data-testid="wh-filter-cmin" />}
          {can(user, "wh_cost") && <Input type="number" min="0" placeholder="Acquisto fino a €" value={f.cmax} onChange={set("cmax")} data-testid="wh-filter-cmax" />}
          <Input type="date" value={f.dfrom} onChange={set("dfrom")} aria-label="Inserito dal" data-testid="wh-filter-dfrom" />
          <Input type="date" value={f.dto} onChange={set("dto")} aria-label="Inserito fino al" data-testid="wh-filter-dto" />
        </div>
      </details>
    </div>
  );
}
